import { Injectable } from '@angular/core';

import { ContinueAuthService } from './continue-auth.service';

@Injectable({
  providedIn: 'root'
})
export class RouteGuardServiceResume  {

  constructor(private authService: ContinueAuthService ) { }

  canActivate(): boolean {
      if(this.authService.isLoggedIn()) {
          return true;
      }

      this.authService.startAuthentication();
      return false;
  }
}
